class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
  }

  renderContents(parsedState) {
    const defaultContent = document.getElementById('cart-notification-default');
    if (defaultContent) defaultContent.innerHTML = '';

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];
      if (!sectionHtml) return;

      /* BOU FIX: el header tiene el id cart-icon-bubble duplicado (desktop y mobile);
         actualizamos TODAS las instancias para que el contador quede al dia en ambos */
      const targets = document.querySelectorAll('[id="' + section.id + '"]');
      if (!targets.length) return;

      const html = this.getSectionInnerHTML(sectionHtml, section.selector);
      targets.forEach((target) => { target.innerHTML = html; });
    });

    const cartIcon = document.querySelector('#cart-icon-bubble');

    if (
      cartIcon &&
      cartIcon.getAttribute('aria-expanded') === 'false'
    ) {
      cartIcon.click();
    }
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
      { id: 'cart-upsell' },
      { id: 'cart-drawer-gift' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentHtml = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const selected = documentHtml.querySelector(selector);

    return selected ? selected.innerHTML : html;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}

(function () {
  'use strict';

  const SECTION_IDS = [
    'cart-notification-product',
    'cart-notification-button',
    'cart-icon-bubble',
    'cart-upsell',
    'cart-drawer-gift'
  ];

  const ATTRIBUTES = {
    active: '_bou_bundle_active',
    mainVariantId: '_bou_main_variant_id',
    upsellVariantIds: '_bou_upsell_variant_ids',
    discountOne: '_bou_discount_one',
    discountTwo: '_bou_discount_two'
  };

  let syncTimer = null;
  let syncInProgress = false;

  function rootUrl(path) {
    const root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    return root + String(path || '').replace(/^\//, '');
  }

  function openUpdatedDrawer(state) {
    const drawer = document.querySelector('cart-notification');

    if (
      drawer &&
      state &&
      state.sections &&
      typeof drawer.renderContents === 'function'
    ) {
      drawer.renderContents(state);
    }

    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else {
      const panel = document.querySelector('.cart-notification');
      const overlay = document.querySelector('.cart-overlay');

      if (panel) panel.classList.add('active');
      if (overlay) overlay.classList.add('active');

      document.body.classList.add('cart-overflow');
    }

    /*
     * BOU FIX: cartUpsellCarousel ya lo llama openCartDrawer();
     * la llamada duplicada re-inicializaba Owl y causaba jank.
     * initMotivatorProduct se mantiene (pendiente decisión de
     * negocio sobre re-agregar el regalo — Paso 5 del plan).
     */
    if (typeof window.initMotivatorProduct === 'function') {
      window.initMotivatorProduct();
    }
  }

  async function readCart() {
    const response = await fetch(rootUrl('cart.js'), {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No fue posible leer el carrito.');
    }

    return response.json();
  }

  async function addItems(items) {
    const response = await fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: SECTION_IDS,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(
        data.description ||
        data.message ||
        'No fue posible agregar los productos.'
      );
    }

    return data;
  }

  async function updateCart(payload) {
    const response = await fetch(rootUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        ...payload,
        sections: SECTION_IDS,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(
        data.description ||
        data.message ||
        'No fue posible actualizar el carrito.'
      );
    }

    return data;
  }

  function getMainProduct() {
    const form = document.getElementById('bou-product-form');

    const variantInput =
      document.getElementById('bou-variant-id') ||
      (form && form.querySelector('input[name="id"]'));

    const quantityInput =
      document.getElementById('bou-qty') ||
      (form && form.querySelector('input[name="quantity"]'));

    return {
      id: variantInput ? Number(variantInput.value) : 0,
      quantity: Math.max(
        1,
        Number(quantityInput ? quantityInput.value : 1) || 1
      )
    };
  }

  function getSelectedUpsells(list) {
    const used = new Set();
    const selected = [];

    list
      .querySelectorAll('[data-bou-upsell-item]')
      .forEach((item) => {
        const checkbox = item.querySelector(
          '[data-bou-upsell-check]'
        );

        const variantId = Number(item.dataset.variantId);

        if (
          !checkbox ||
          !checkbox.checked ||
          checkbox.disabled ||
          !variantId ||
          used.has(variantId)
        ) {
          return;
        }

        used.add(variantId);

        selected.push({
          id: variantId,
          quantity: 1
        });
      });

    return selected;
  }

  function buildBundleAttributes({
    mainVariantId,
    upsellVariantIds,
    discountOne,
    discountTwo
  }) {
    return {
      [ATTRIBUTES.active]: 'true',
      [ATTRIBUTES.mainVariantId]: String(mainVariantId || ''),
      [ATTRIBUTES.upsellVariantIds]: upsellVariantIds.join(','),
      [ATTRIBUTES.discountOne]: String(discountOne || ''),
      [ATTRIBUTES.discountTwo]: String(discountTwo || '')
    };
  }

  function emptyBundleAttributes() {
    return {
      [ATTRIBUTES.active]: '',
      [ATTRIBUTES.mainVariantId]: '',
      [ATTRIBUTES.upsellVariantIds]: '',
      [ATTRIBUTES.discountOne]: '',
      [ATTRIBUTES.discountTwo]: ''
    };
  }

  function getPresentBundleState(cart) {
    const attributes = cart.attributes || {};

    const active =
      String(attributes[ATTRIBUTES.active] || '') === 'true';

    const mainVariantId = Number(
      attributes[ATTRIBUTES.mainVariantId] || 0
    );

    const upsellVariantIds = String(
      attributes[ATTRIBUTES.upsellVariantIds] || ''
    )
      .split(',')
      .map((value) => Number(value))
      .filter(Boolean);

    const discountOne = String(
      attributes[ATTRIBUTES.discountOne] || ''
    ).trim();

    const discountTwo = String(
      attributes[ATTRIBUTES.discountTwo] || ''
    ).trim();

    const cartVariantIds = (cart.items || []).map((item) =>
      Number(item.variant_id)
    );

    const mainPresent =
      mainVariantId > 0 &&
      cartVariantIds.includes(mainVariantId);

    const presentUpsells = upsellVariantIds.filter((variantId) =>
      cartVariantIds.includes(variantId)
    );

    return {
      active,
      mainVariantId,
      mainPresent,
      presentUpsells,
      discountOne,
      discountTwo
    };
  }

  function desiredDiscountCode(bundleState) {
    if (
      !bundleState.mainPresent ||
      bundleState.presentUpsells.length === 0
    ) {
      return '';
    }

    if (bundleState.presentUpsells.length >= 2) {
      return bundleState.discountTwo;
    }

    return bundleState.discountOne;
  }

  async function synchronizeBundleDiscount({
    openDrawer = false
  } = {}) {
    if (syncInProgress) return;

    /*
     * BOU FIX: si nunca se activó un bundle en esta sesión,
     * no hay nada que sincronizar. Evita un fetch a /cart.js
     * en cada clic del drawer para el 95% de los usuarios.
     */
    try {
      if (window.sessionStorage && sessionStorage.getItem('bou_bundle') !== '1') {
        return;
      }
    } catch (e) { /* sessionStorage bloqueado: continuar normal */ }

    syncInProgress = true;

    try {
      const cart = await readCart();
      const bundleState = getPresentBundleState(cart);

      if (!bundleState.active) return;

      const desiredCode = desiredDiscountCode(bundleState);

      /*
       * Regla clave:
       * Si se elimina el producto principal, se quita el código
       * y se borran los datos del bundle.
       */
      if (!bundleState.mainPresent) {
        const state = await updateCart({
          discount: '',
          attributes: emptyBundleAttributes()
        });

        if (openDrawer) {
          openUpdatedDrawer(state);
        }

        return;
      }

      /*
       * Si ya no queda ningún upsell, también se quita el descuento.
       */
      if (bundleState.presentUpsells.length === 0) {
        const state = await updateCart({
          discount: '',
          attributes: emptyBundleAttributes()
        });

        if (openDrawer) {
          openUpdatedDrawer(state);
        }

        return;
      }

      /*
       * Si quedan upsells:
       * 1 producto  → descuento 1
       * 2 o más     → descuento 2
       */
      const payload = {
        attributes: {
          ...buildBundleAttributes({
            mainVariantId: bundleState.mainVariantId,
            upsellVariantIds: bundleState.presentUpsells,
            discountOne: bundleState.discountOne,
            discountTwo: bundleState.discountTwo
          })
        }
      };

      if (desiredCode) {
        payload.discount = desiredCode;
      }

      const state = await updateCart(payload);

      if (openDrawer) {
        openUpdatedDrawer(state);
      }
    } catch (error) {
      console.warn(
        'BOU: no fue posible sincronizar el descuento:',
        error
      );
    } finally {
      syncInProgress = false;
    }
  }

  function scheduleBundleSync(delay = 900) {
    window.clearTimeout(syncTimer);

    syncTimer = window.setTimeout(() => {
      synchronizeBundleDiscount({
        openDrawer: true
      });
    }, delay);
  }

  async function handleAddAll(button, list) {
    const status = list.querySelector(
      '[data-bou-upsell-status]'
    );

    const buttonText = button.querySelector(
      '[data-bou-upsell-button-text]'
    );

    const originalText =
      button.dataset.label ||
      (buttonText
        ? buttonText.textContent
        : 'AGREGAR TODO');

    const main = getMainProduct();
    const upsells = getSelectedUpsells(list);

    if (!main.id) {
      if (status) {
        status.textContent =
          'No se pudo detectar el producto principal.';
      }

      return;
    }

    if (!upsells.length) {
      if (status) {
        status.textContent =
          'Selecciona al menos un complemento.';
      }

      return;
    }

    button.disabled = true;

    if (buttonText) {
      buttonText.textContent = 'AGREGANDO...';
    }

    if (status) {
      status.textContent = '';
    }

    try {
      const cart = await readCart();

      const mainAlreadyInCart = (cart.items || []).some(
        (item) => Number(item.variant_id) === main.id
      );

      const items = [];

      if (!mainAlreadyInCart) {
        items.push({
          id: main.id,
          quantity: main.quantity
        });
      }

      upsells.forEach((item) => {
        items.push(item);
      });

      await addItems(items);

      const discountOne = String(
        list.dataset.discountCodeOne || ''
      ).trim();

      const discountTwo = String(
        list.dataset.discountCodeTwo || ''
      ).trim();

      const selectedUpsellIds = upsells.map(
        (item) => item.id
      );

      const discountCode =
        selectedUpsellIds.length >= 2
          ? discountTwo
          : discountOne;

      const updatePayload = {
        attributes: buildBundleAttributes({
          mainVariantId: main.id,
          upsellVariantIds: selectedUpsellIds,
          discountOne,
          discountTwo
        })
      };

      if (discountCode) {
        updatePayload.discount = discountCode;
      }

      /* BOU FIX: marcar que hay bundle activo en esta sesión */
      try {
        if (window.sessionStorage) sessionStorage.setItem('bou_bundle', '1');
      } catch (e) { /* noop */ }

      const finalState = await updateCart(updatePayload);

      openUpdatedDrawer(finalState);

      if (buttonText) {
        buttonText.textContent = '✓ AGREGADOS';
      }

      if (status) {
        status.textContent = mainAlreadyInCart
          ? 'Complementos agregados. El producto principal ya estaba en el carrito.'
          : 'Producto principal y complementos agregados al carrito.';
      }
    } catch (error) {
      console.warn('BOU upsell:', error);

      if (buttonText) {
        buttonText.textContent = 'INTENTAR DE NUEVO';
      }

      if (status) {
        status.textContent =
          error.message ||
          'No se pudieron agregar los productos.';
      }
    } finally {
      window.setTimeout(() => {
        button.disabled = false;

        if (buttonText) {
          buttonText.textContent = originalText;
        }
      }, 2200);
    }
  }

  /*
   * Intercepta solamente el botón AGREGAR TODO del upsell.
   */
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '[data-bou-upsell-add-all]'
      );

      if (!button) return;

      const list = button.closest(
        '[data-bou-upsell-list]'
      );

      if (!list) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (!button.disabled) {
        handleAddAll(button, list);
      }
    },
    true
  );

  /*
   * Después de quitar o cambiar cantidades en el cart drawer,
   * vuelve a revisar que siga existiendo el principal.
   */
  document.addEventListener(
    'click',
    function (event) {
      const cartControl = event.target.closest(
        [
          '.cart-remove-js',
          '.minicart-quantity__button',
          'cart-remove-button',
          '[data-cart-remove]',
          'a[href*="/cart/change"]'
        ].join(',')
      );

      if (!cartControl) return;

      scheduleBundleSync(1000);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.matches(
          '.cart-notification .quantity__input, ' +
          '.cart-drawer .quantity__input, ' +
          'input[name="updates[]"]'
        )
      ) {
        scheduleBundleSync(1000);
      }
    },
    true
  );

  /*
   * Revisa un bundle activo al cargar la página.
   */
  window.setTimeout(() => {
    synchronizeBundleDiscount({
      openDrawer: false
    });
  }, 700);
})();